<template>
  <div class="menu-folder-modern">
    <!-- Header Section -->
    <div class="folders-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="section-title">
            <i class="fas fa-folder title-icon"></i>

            Pastas
          </h2>

          <p class="section-subtitle">
            Organize documentos e arquivos do residente
          </p>
        </div>

        <div class="actions-section" v-if="permission('write', 'folder')">
          <v-btn class="btn-add-modern" @click="$bvModal.show('createFolder')">
            <i class="fas fa-plus mr-2"></i>
            <span>Nova Pasta</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="folder-content">
      <!-- Public Folders Section -->
      <div class="folder-section">
        <div class="section-header">
          <div class="section-title">
            <i class="fas fa-globe section-icon"></i>
            <h3>Pastas Públicas</h3>
            <span class="folder-count">{{ foldersPublics.length }}</span>
          </div>
        </div>
        <div class="section-content">
          <ListFolder
            :folders="foldersPublics"
            @change="getFolders"
            @noResults="handleNoResults('public', true)"
            @hasResults="handleNoResults('public', false)"
          />
        </div>
      </div>

      <!-- Private Folders Section -->
      <div class="folder-section">
        <div class="section-header">
          <div class="section-title">
            <i class="fas fa-lock section-icon"></i>
            <h3>Pastas Privadas</h3>
            <span class="folder-count">{{ foldersPrivates.length }}</span>
          </div>
        </div>
        <div class="section-content">
          <ListFolder
            :folders="foldersPrivates"
            @change="getFolders"
            @noResults="handleNoResults('private', true)"
            @hasResults="handleNoResults('private', false)"
          />
        </div>
      </div>

      <!-- No Results State -->
    </div>

    <!-- Create Folder Modal -->
    <CreateFolder :selected_resident_id="resident_id" @create="getFolders" />
  </div>
</template>

<script>
import api from "../../services/api";
import ListFolder from "../../templates/Folder/ListFolder";
import CreateFolder from "../../templates/Folder/CreateFolder";
import permission from "../../lib/permission";

export default {
  name: "MenuFolder",

  components: {
    ListFolder,
    CreateFolder,
  },

  data() {
    return {
      folder_id: null,
      foldersPublics: [],
      foldersPrivates: [],
      noResultsPublic: false,
      noResultsPrivate: false,
      noResults: false,
      loading: false,
    };
  },

  async created() {
    await this.getFolders();
  },

  props: {
    resident_id: Number,
  },

  watch: {
    resident_id() {
      this.getFolders();
    },
  },

  methods: {
    permission,

    async getFolders() {
      try {
        this.loading = true;

        const { resident_id } = this;
        let params = { resident_id };

        const response = await api.get("/folder/resident", { params });
        const { foldersPublics, foldersPrivates } = response.data;

        this.foldersPublics = foldersPublics;
        this.foldersPrivates = foldersPrivates;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    handleNoResults(type, value) {
      if (type == "public") {
        this.noResultsPublic = value;
      } else if (type == "private") {
        this.noResultsPrivate = value;
      }

      this.noResults = this.noResultsPublic && this.noResultsPrivate;
    },
  },
};
</script>

<style scoped>
.menu-folder-modern {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;
}

/* Header Section */
.folders-header {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 20px;
}

.section-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 14px;
}

.actions-section {
  display: flex;
  gap: 12px;
}

/* Modern Button */
.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  margin-left: auto !important;
  display: block !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

/* Content Section */
.folder-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Folder Sections */
.folder-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  flex: 1;
}

.section-icon {
  color: #0f65b0;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.folder-count {
  background: #0f65b0;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.section-content {
  padding: 24px;
}

/* No Results State */
.no-results-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 48px 24px;
}

.no-results-content {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}

.no-results-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  border: 2px solid #e5e7eb;
}

.no-results-icon i {
  font-size: 32px;
  color: #94a3b8;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #64748b;
  font-size: 14px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.no-results-suggestion {
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.suggestion-text {
  color: #374151;
  font-size: 14px;
  margin: 0 0 16px 0;
  font-weight: 500;
}

.btn-create-suggestion {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-create-suggestion:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .folder-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px;
  }

  .header-content {
    text-align: center;
  }

  .folder-title {
    font-size: 20px;
    justify-content: center;
  }

  .section-header {
    padding: 16px 20px;
  }

  .section-content {
    padding: 20px;
  }

  .no-results-card {
    padding: 32px 20px;
  }

  .no-results-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }

  .no-results-icon i {
    font-size: 24px;
  }

  .no-results-title {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .menu-folder-modern {
    gap: 16px;
  }

  .folder-header {
    padding: 16px;
  }

  .folder-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }

  .folder-subtitle {
    font-size: 13px;
  }

  .section-title {
    gap: 8px;
  }

  .section-title h3 {
    font-size: 14px;
  }

  .folder-count {
    font-size: 11px;
    padding: 3px 8px;
  }

  .btn-add-modern,
  .btn-create-suggestion {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }

  .no-results-title {
    font-size: 16px;
  }

  .no-results-text,
  .suggestion-text {
    font-size: 13px;
  }
}

/* Animation for smooth transitions */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.folder-section {
  animation: slideIn 0.3s ease forwards;
}

.folder-section:nth-child(1) {
  animation-delay: 0.1s;
}

.folder-section:nth-child(2) {
  animation-delay: 0.2s;
}
</style>